import { trackEvent, trackPage } from "./analytics";

export const safeTrackPage = (url) => {
  trackPage(url);
};

export const safeTrackEvent = (name, params) => {
  trackEvent(name, params);
};
